// extracted by mini-css-extract-plugin
export default {"wrapper":"CharacterWithBubble_wrapper__6Muhy","bubble":"CharacterWithBubble_bubble__9uDoH","area":"CharacterWithBubble_area__3wFAS","image":"CharacterWithBubble_image__TVQ31"};